//
;(() => {
    const leftHiderClass = 'js-scrollable-with-hiders--hider-left'
    const rightHiderClass = 'js-scrollable-with-hiders--hider-right'

    document.querySelectorAll('.js-scrollable-with-hiders').forEach(scrollable => {
        const content = scrollable.querySelector('.js-scrollable-with-hiders__content')
        const wrapper = scrollable.querySelector('.js-scrollable-with-hiders__wrapper')

        if (!content || !wrapper) return

        const sideOffset = 3

        const detectScroll = e => {
            const scrollLeft = wrapper.scrollLeft
            const scrollableWidth = scrollable.offsetWidth
            const contentWidth = getChildrenWidth(content)

            if (scrollLeft > sideOffset) {
                scrollable.classList.add(leftHiderClass)
            } else {
                scrollable.classList.remove(leftHiderClass)
            }

            if (scrollLeft + scrollableWidth + sideOffset < contentWidth) {
                scrollable.classList.add(rightHiderClass)
            } else {
                scrollable.classList.remove(rightHiderClass)
            }
        }

        const update = () => {
            scrollable.classList.remove(leftHiderClass)
            scrollable.classList.remove(rightHiderClass)
            detectScroll()
        }

        const setInitialScroll = () => {
            wrapper.scrollLeft = parseInt(scrollable.dataset.initialScrollLeft) || 0
        }

        detectScroll()
        
        setTimeout(() => {
            setInitialScroll()
        }, 50)

        wrapper.addEventListener('scroll', detectScroll)
        window.addEventListener('resize', update)

        // if (screen) {
        //     screen.orientation.addEventListener('change', update)
        // }

    })

    function getChildrenWidth(container) {
        const children = container.children;
        let totalWidth = 0;

        for (let i = 0; i < children.length; ++i) {
            const style = children[i].currentStyle || window.getComputedStyle(children[i])
            totalWidth += parseInt(children[i].getBoundingClientRect().width, 10)
            totalWidth += parseFloat(style.marginLeft) + parseFloat(style.marginRight)
        }

        return totalWidth
    }
})();
